/* SQUISHERÍA theme JS — carrito AJAX, selector de mascotas, mantequilla achuchable */
(function () {
  "use strict";
  const S = (window.SQ && window.SQ.strings) || {};
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);

  /* ══════════ Toast ══════════ */
  let toastTimer;
  function toast(msg) {
    const el = $("#Toast");
    if (!el) return;
    el.textContent = msg;
    el.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove("show"), 2600);
  }

  /* ══════════ Cesta deslizante ══════════ */
  let cartOpen = false;
  function drawer() { return $("#Drawer"); }
  function overlay() { return $("#Overlay"); }
  function openCart() {
    cartOpen = true;
    drawer() && drawer().classList.add("open");
    overlay() && overlay().classList.add("show");
    document.body.classList.add("no-scroll");
    drawer() && drawer().focus();
  }
  function closeCart() {
    cartOpen = false;
    drawer() && drawer().classList.remove("open");
    overlay() && overlay().classList.remove("show");
    document.body.classList.remove("no-scroll");
  }

  async function refreshDrawer(open) {
    try {
      const res = await fetch(location.pathname + "?sections=cart-drawer");
      const data = await res.json();
      const holder = $("#shopify-section-cart-drawer");
      if (holder && data["cart-drawer"]) {
        const tmp = document.createElement("div");
        tmp.innerHTML = data["cart-drawer"];
        holder.replaceWith(tmp.firstElementChild);
      }
      updateCounts();
      if (open || cartOpen) openCart();
    } catch (e) { /* silencioso */ }
  }

  async function updateCounts() {
    try {
      const cart = await (await fetch("/cart.js")).json();
      document.querySelectorAll("[data-cart-count]").forEach((el) => {
        el.textContent = cart.item_count;
        el.classList.remove("bump"); void el.offsetWidth; el.classList.add("bump");
      });
    } catch (e) { /* silencioso */ }
  }

  /* ══════════ Añadir a la cesta (AJAX) ══════════ */
  document.addEventListener("submit", async (e) => {
    const form = e.target.closest('form[data-ajax-add]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const original = btn ? btn.textContent : "";
    if (btn) { btn.disabled = true; btn.textContent = S.adding || "…"; }
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        body: new FormData(form),
        headers: { Accept: "application/json" },
      });
      if (res.ok) {
        const title = form.dataset.title || "";
        toast((S.added || "{{ title }} ✓").replace("{{ title }}", title));
        if (btn) btn.textContent = "✓";
        await refreshDrawer(true);
      } else {
        const j = await res.json().catch(() => ({}));
        toast(j.description || j.message || S.error || "Error");
      }
    } catch (err) {
      toast(S.error || "Error");
    } finally {
      if (btn) setTimeout(() => { btn.disabled = false; btn.textContent = original; }, 900);
    }
  });

  /* ══════════ Delegación de clics ══════════ */
  document.addEventListener("click", async (e) => {
    const t = e.target;

    if (t.closest("[data-cart-open]")) { e.preventDefault(); openCart(); return; }
    if (t.closest("[data-cart-close]")) { e.preventDefault(); closeCart(); return; }

    /* Cantidades dentro de la cesta deslizante */
    const qbtn = t.closest("[data-qty-change]");
    if (qbtn) {
      e.preventDefault();
      const line = qbtn.dataset.line;
      const delta = parseInt(qbtn.dataset.delta, 10);
      const span = qbtn.parentElement && qbtn.parentElement.querySelector("[data-qty]");
      const current = span ? parseInt(span.dataset.qty, 10) : 1;
      const quantity = Math.max(0, current + delta);
      qbtn.disabled = true;
      try {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: line, quantity }),
        });
        await refreshDrawer(true);
      } catch (err) { toast(S.error || "Error"); }
      return;
    }

    /* Cantidad en ficha de producto */
    const minus = t.closest("[data-qty-minus]");
    const plus = t.closest("[data-qty-plus]");
    if (minus || plus) {
      const box = (minus || plus).parentElement;
      const input = box && box.querySelector('input[name="quantity"]');
      if (input) {
        const v = Math.max(1, (parseInt(input.value, 10) || 1) + (plus ? 1 : -1));
        input.value = v;
      }
      return;
    }

    /* Miniaturas de la galería de producto */
    const thumb = t.closest("[data-gallery-thumb]");
    if (thumb) {
      const main = $("#MainProductImage");
      if (main && thumb.dataset.full) {
        main.src = thumb.dataset.full;
        main.removeAttribute("srcset");
        main.classList.remove("pop"); void main.offsetWidth; main.classList.add("pop");
      }
      thumb.closest(".star-picker") &&
        thumb.closest(".star-picker").querySelectorAll(".pick").forEach((b) => b.classList.toggle("on", b === thumb));
      return;
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && cartOpen) closeCart();
  });

  /* ══════════ Producto estrella: selector de mascotas ══════════ */
  document.querySelectorAll("[data-star-products]").forEach((jsonEl) => {
    let products;
    try { products = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    if (!products || !products.length) return;

    const root = jsonEl.closest(".star");
    const stage = $("[data-star-stage]", root);
    const stamp = $("[data-star-stamp]", root);
    const nameEl = $("[data-star-name]", root);
    const leadEl = $("[data-star-lead]", root);
    const chipsEl = $("[data-star-chips]", root);
    const priceEl = $("[data-star-price]", root);
    const wasEl = $("[data-star-was]", root);
    const offEl = $("[data-star-off]", root);
    const addBtn = $("[data-star-add]", root);
    const linkEl = $("[data-star-link]", root);
    const addLabel = addBtn ? addBtn.textContent : "";
    let idx = 0;

    const visualEl = root.querySelector(".star-visual");

    /* ── mano achuchona ── */
    const HAND_SVG = '<svg class="sq-hand" viewBox="0 0 200 390" aria-hidden="true">' +
      '<g stroke="#3B2417" stroke-width="7" stroke-linejoin="round" stroke-linecap="round">' +
      '<g fill="#FFCFA8">' +
      '<rect class="finger f1" x="58" y="40" width="26" height="80" rx="13"/>' +
      '<rect class="finger f2" x="87" y="28" width="27" height="92" rx="13.5"/>' +
      '<rect class="finger f3" x="117" y="38" width="26" height="82" rx="13"/>' +
      '<rect class="finger f4" x="146" y="58" width="23" height="62" rx="11.5"/>' +
      '<g transform="rotate(-30 46 148)"><rect class="thumb" x="20" y="96" width="26" height="62" rx="13"/></g>' +
      '</g>' +
      '<path fill="#FFCFA8" d="M72,168 q28,-7 56,0 q6,2 7,12 l9,210 h-88 l9,-210 q1,-10 7,-12 z"/>' +
      '<path fill="#FFD9B8" d="M48,112 h108 a22,22 0 0 1 22,22 v32 a58,58 0 0 1 -58,58 h-36 a58,58 0 0 1 -58,-58 v-32 a22,22 0 0 1 22,-22 z"/>' +
      '<path fill="none" stroke-width="5" opacity=".4" d="M64,152 q38,16 74,0"/>' +
      '</g></svg>';

    if (visualEl) {
      const wrap = document.createElement("div");
      wrap.className = "sq-hand-wrap";
      wrap.setAttribute("aria-hidden", "true");
      wrap.innerHTML = '<div class="sq-hand-pos">' + HAND_SVG + "</div>";
      visualEl.appendChild(wrap);
    }

    function playSquish() {
      if (!visualEl || !visualEl.querySelector(".sq-hand")) return;
      visualEl.classList.remove("is-squishing");
      void visualEl.offsetWidth;
      visualEl.classList.add("is-squishing");
    }

    const shotCache = {};
    let shotReq = 0;
    let seqTimers = [];

    function sized(url, size) {
      return url.replace(/(\.(?:jpe?g|png|webp|gif))(\?|$)/i, "_" + size + "$1$2");
    }

    async function loadShots(p) {
      if (shotCache[p.url]) return shotCache[p.url];
      try {
        const res = await fetch(p.url + ".js", { headers: { Accept: "application/json" } });
        if (!res.ok) throw new Error("no");
        const data = await res.json();
        shotCache[p.url] = data.images || [];
      } catch (err) {
        shotCache[p.url] = [];
      }
      return shotCache[p.url];
    }

    function showShot(url) {
      const img = stage && stage.querySelector("img");
      if (!img) return;
      img.src = url;
      img.removeAttribute("srcset");
    }

    /* relevo en el pico del apreton: la foto 1 se aplasta, la 2 rebota.
       La animacion vive en el <img> y no se reinicia al cambiar el src,
       asi que la segunda foto entra ya comprimida y sigue el movimiento. */
    function swapShot(url) {
      const img = stage && stage.querySelector("img");
      if (!img) return;
      img.style.transition = "opacity .06s linear";
      img.style.opacity = ".3";
      seqTimers.push(setTimeout(function () {
        img.src = url;
        img.removeAttribute("srcset");
        img.style.opacity = "1";
        seqTimers.push(setTimeout(function () {
          img.style.transition = "";
          img.style.opacity = "";
        }, 150));
      }, 60));
    }

    /* reflejo que atraviesa la foto, recortado a su silueta */
    function flashShine() {
      if (!stage) return;
      const img = stage.querySelector("img");
      if (!img) return;
      const old = stage.querySelector(".sq-shine");
      if (old) old.remove();
      const sh = document.createElement("span");
      sh.className = "sq-shine";
      const src = img.currentSrc || img.src;
      if (!src) return;
      const m = 'url("' + src + '")';
      sh.style.width = img.offsetWidth + "px";
      sh.style.height = img.offsetHeight + "px";
      sh.style.webkitMaskImage = m;
      sh.style.maskImage = m;
      stage.appendChild(sh);
      sh.addEventListener("animationend", function () { sh.remove(); });
    }

    function clearSeq() {
      seqTimers.forEach(clearTimeout);
      seqTimers = [];
    }

    /* coreografia
       0.0s  el blister ya esta en pantalla y la mano empieza a subir
       0.8s  la mano llega y empieza a apretar
       1.28s en el pico del apreton, relevo a la foto del squishy suelto
       2.0s  la mano baja y se esconde
       2.6s  vuelve el blister, se asienta y le cruza un reflejo          */
    function playSequence(shots, p) {
      if (!visualEl) return;
      clearSeq();
      visualEl.classList.remove("is-squishing", "is-settling");
      void visualEl.offsetWidth;
      visualEl.classList.add("is-squishing");

      const tieneSuelto = shots && shots.length > 1;

      if (tieneSuelto) {
        seqTimers.push(setTimeout(function () {
          swapShot(sized(shots[1], "900x"));
        }, 1220));
      }

      seqTimers.push(setTimeout(function () {
        /* vuelve la misma imagen que ya estaba cargada: sin recarga ni parpadeo */
        if (tieneSuelto) showShot(p && p.img ? p.img : sized(shots[0], "900x"));
        visualEl.classList.remove("is-settling");
        void visualEl.offsetWidth;
        visualEl.classList.add("is-settling");
        setTimeout(flashShine, 260);
      }, 2600));

      seqTimers.push(setTimeout(function () {
        visualEl.classList.remove("is-squishing");
      }, 3300));
    }

    function render() {
      const p = products[idx];
      if (stage) {
        stage.innerHTML = p.img
          ? '<img class="star-photo' + (p.transparent ? " is-cut" : "") + '" src="' + p.img + '" alt="' + (p.imgAlt || "").replace(/"/g, "&quot;") + '">'
          : (p.mascot ? '<svg viewBox="0 0 120 120" role="img" aria-label=""><use href="#sv-' + p.mascot + '"/></svg>' : "");
      }
      const visual = root.querySelector(".star-visual");
      if (visual) visual.style.setProperty("--pc", p.color);
      if (stamp) stamp.hidden = !p.stamp;
      if (nameEl) nameEl.textContent = p.title.toUpperCase();
      if (leadEl) leadEl.textContent = p.lead || "";
      if (chipsEl) chipsEl.innerHTML = (p.chips || []).map((c) => '<span class="chip"></span>').join("");
      if (chipsEl) chipsEl.querySelectorAll(".chip").forEach((el, i) => (el.textContent = p.chips[i]));
      if (priceEl) priceEl.textContent = p.price;
      if (wasEl) { wasEl.hidden = !p.was; wasEl.textContent = p.was || ""; }
      if (offEl) { offEl.hidden = !p.off; offEl.textContent = p.off ? "-" + p.off + "%" : ""; }
      if (addBtn) {
        addBtn.disabled = !p.available;
        addBtn.textContent = p.available ? addLabel : (S.soldout || "—");
      }
      if (linkEl) linkEl.href = p.url;
      clearSeq();
      if (visualEl) visualEl.classList.remove("is-squishing", "is-settling");
      const my = ++shotReq;
      const ya = shotCache[p.url];
      if (ya) {
        /* fotos en memoria: arranca al instante */
        playSequence(ya, p);
      } else {
        /* primera vez: espera como mucho 600 ms a las fotos y arranca igual */
        let lanzada = false;
        const arranca = function (shots) {
          if (lanzada || my !== shotReq) return;
          lanzada = true;
          playSequence(shots, p);
        };
        loadShots(p).then(arranca);
        setTimeout(function () { arranca(null); }, 600);
      }
      root.querySelectorAll("[data-star-pick]").forEach((b) => {
        const on = parseInt(b.dataset.starPick, 10) === idx;
        b.classList.toggle("on", on);
        b.setAttribute("aria-selected", on);
      });
    }

    root.addEventListener("click", async (e) => {
      const pick = e.target.closest("[data-star-pick]");
      if (pick) { idx = parseInt(pick.dataset.starPick, 10) || 0; render(); return; }
      if (e.target.closest("[data-star-add]")) {
        const p = products[idx];
        if (!p.available) return;
        addBtn.disabled = true;
        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ id: p.id, quantity: 1 }),
          });
          if (res.ok) {
            toast((S.added || "{{ title }} ✓").replace("{{ title }}", p.title));
            await refreshDrawer(true);
          } else {
            const j = await res.json().catch(() => ({}));
            toast(j.description || S.error || "Error");
          }
        } catch (err) { toast(S.error || "Error"); }
        addBtn.disabled = false;
      }
    });

    /* precarga: asi el cambio de foto es instantaneo desde el primer clic */
    products.forEach(function (p) {
      loadShots(p).then(function (shots) {
        if (!shots) return;
        shots.slice(0, 2).forEach(function (u) {
          const im = new Image(); im.src = sized(u, "900x");
        });
      });
    });

    render();
  });

  /* ══════════ Selector de pais y moneda ══════════ */
  (function () {
    const form = $("[data-geo]");
    if (!form) return;

    const btn    = $("[data-geo-open]", form);
    const panel  = $("[data-geo-panel]", form);
    const search = $("[data-geo-search]", form);
    const inputC = $("[data-geo-country]", form);
    const inputL = $("[data-geo-lang]", form);
    if (!btn || !panel) return;

    /* paises donde se habla espanol: el resto ve la tienda en ingles */
    const ES = ["ES","MX","AR","CO","CL","PE","VE","EC","GT","CU","BO","DO",
                "HN","PY","SV","NI","CR","PA","UY","GQ","PR","AD"];

    /* el codigo ISO se convierte en bandera con los simbolos regionales */
    function flag(code) {
      if (!code || code.length !== 2) return "🌍";
      return String.fromCodePoint(
        0x1f1e6 + code.charCodeAt(0) - 65,
        0x1f1e6 + code.charCodeAt(1) - 65
      );
    }
    document.querySelectorAll("[data-flag]").forEach(function (el) {
      el.textContent = flag(el.dataset.flag);
    });
    const flagBtn = $("[data-geo-flag]", btn);
    if (flagBtn) flagBtn.textContent = flag(btn.dataset.current || "");

    function abrir(v) {
      panel.hidden = !v;
      btn.setAttribute("aria-expanded", v ? "true" : "false");
      if (v && search) { search.value = ""; filtrar(""); setTimeout(function () { search.focus(); }, 30); }
    }
    function filtrar(q) {
      const t = q.trim().toLowerCase();
      panel.querySelectorAll("[data-geo-pick]").forEach(function (b) {
        const n = (b.dataset.name || "").toLowerCase();
        b.parentElement.hidden = t !== "" && n.indexOf(t) === -1;
      });
    }

    btn.addEventListener("click", function () { abrir(panel.hidden); });
    if (search) search.addEventListener("input", function () { filtrar(search.value); });

    document.addEventListener("click", function (e) {
      if (!form.contains(e.target)) abrir(false);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !panel.hidden) { abrir(false); btn.focus(); }
    });

    panel.addEventListener("click", function (e) {
      const pick = e.target.closest("[data-geo-pick]");
      if (!pick) return;
      const pais = pick.dataset.geoPick;
      inputC.value = pais;
      /* el idioma acompana al pais: espanol donde se habla, ingles en el resto */
      if (inputL) {
        const quiere = ES.indexOf(pais) === -1 ? "en" : "es";
        const hay = (form.dataset.locales || "").split(",");
        if (hay.indexOf(quiere) !== -1) inputL.value = quiere;
      }
      btn.disabled = true;
      form.submit();
    });
  })();

  /* ══════════ Pop-up de bienvenida con descuento ══════════ */
  /* El pop-up y su formulario viven en la seccion 'popup' del tema: el alta
     tiene que pasar por un formulario real de Shopify para superar su captcha
     invisible. Aqui solo se controla cuando se abre y el paso del codigo.   */
  (function () {
    const pop = $("[data-sqpop]");
    if (!pop) return;

    const CODIGO = pop.dataset.code || "";
    const DIAS   = parseInt(pop.dataset.days, 10) || 0;   // 0 = en cada visita
    const ESPERA = parseInt(pop.dataset.delay, 10) || 5000;
    const KEY    = "sq-pop-" + CODIGO;        // ya se mostro
    const KEY_OK = "sq-code-" + CODIGO;       // ya consiguio el codigo

    const paso1 = $("[data-pop-step1]", pop);
    const paso2 = $("[data-pop-step2]", pop);
    const aplicar = $("[data-pop-apply]", pop);

    /* con DIAS a 0 solo se guarda para esta visita: al volver otro dia,
       o en otra pestaña nueva, el pop-up aparece de nuevo */
    function almacen() {
      try { return DIAS > 0 ? localStorage : sessionStorage; } catch (e) { return null; }
    }
    function mostrado() {
      try {
        const s = almacen(); if (!s) return false;
        const t = s.getItem(KEY);
        if (!t) return false;
        return DIAS > 0 ? (Date.now() - (+t)) < DIAS * 864e5 : true;
      } catch (e) { return false; }
    }
    function marcar() {
      try { const s = almacen(); s && s.setItem(KEY, String(Date.now())); } catch (e) {}
    }
    function tieneCodigo() {
      try { return !!localStorage.getItem(KEY_OK); } catch (e) { return false; }
    }
    function guardarCodigo() {
      try { localStorage.setItem(KEY_OK, String(Date.now())); } catch (e) {}
    }

    /* el descuento se aplica y devuelve a la misma pagina */
    function enlaceDescuento() {
      const base = location.pathname || "/";
      const q = location.search.replace(/[?&](dto=ok|customer_posted=true)/g, "");
      const limpio = q === "?" ? "" : q;
      const volver = base + (limpio ? limpio + "&" : "?") + "dto=ok";
      return "/discount/" + CODIGO + "?redirect=" + encodeURIComponent(volver);
    }
    if (aplicar) aplicar.href = enlaceDescuento();

    function abrir(conCodigo) {
      pop.hidden = false;
      paso1.hidden = !!conCodigo;
      paso2.hidden = !conCodigo;
      requestAnimationFrame(function () { pop.classList.add("on"); });
      marcar();
      if (!conCodigo) {
        const inp = pop.querySelector('input[type="email"]');
        setTimeout(function () { inp && inp.focus(); }, 320);
      }
    }
    function cerrar() {
      pop.classList.remove("on");
      setTimeout(function () { pop.hidden = true; }, 260);
    }

    pop.addEventListener("click", function (e) {
      if (e.target.closest("[data-pop-close]")) { cerrar(); return; }
      const c = e.target.closest("[data-pop-copy]");
      if (c) {
        try {
          navigator.clipboard.writeText(CODIGO);
          const antes = c.textContent;
          c.textContent = "✓";
          setTimeout(function () { c.textContent = antes; }, 1600);
        } catch (err) {}
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !pop.hidden) cerrar();
    });

    function quitarParam(re) {
      try {
        const q = location.search.replace(re, "").replace(/^&/, "?").replace(/^\?$/, "");
        history.replaceState({}, "", location.pathname + q);
      } catch (e) {}
    }

    /* 1) vuelve del alta: Shopify redirige con customer_posted=true */
    if (location.search.indexOf("customer_posted=true") !== -1) {
      guardarCodigo();
      quitarParam(/[?&]customer_posted=true/);
      if (aplicar) aplicar.href = enlaceDescuento();
      setTimeout(function () { abrir(true); }, 400);
      return;
    }

    /* 2) vuelve de aplicar el descuento: solo confirmar */
    if (location.search.indexOf("dto=ok") !== -1) {
      guardarCodigo();
      marcar();
      quitarParam(/[?&]dto=ok/);
      setTimeout(function () {
        const en = (document.documentElement.lang || "es").slice(0, 2) === "en";
        toast(en ? "Discount applied! " + pop.dataset.pct + "% off at checkout 🎉"
                 : "¡Descuento aplicado! " + pop.dataset.pct + " % al pagar 🎉");
      }, 700);
      return;
    }

    if (location.search.indexOf("nopopup") !== -1) return;
    if (mostrado()) return;

    /* si ya nos dejo su email otra vez, se le enseña directamente el codigo */
    setTimeout(function () { abrir(tieneCodigo()); }, ESPERA);
  })();

  /* ══════════ Ficha de producto: variantes ══════════ */
  const variantsEl = $("[data-variants-json]");
  if (variantsEl) {
    let variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch (err) {}
    const selects = document.querySelectorAll(".opt-select");
    const idInput = $("[data-variant-id]");
    const priceEl = $("[data-product-price]");
    const wasEl = $("[data-product-was]");
    const offEl = $("[data-product-off]");
    const buyBtn = $("[data-buy-button]");
    const buyLabel = buyBtn ? buyBtn.textContent.trim() : "";

    function currentOptions() {
      return Array.from(selects).map((s) => s.value);
    }
    function onChange() {
      const opts = currentOptions();
      const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (wasEl) { wasEl.hidden = !v.was; wasEl.textContent = v.was || ""; }
      if (offEl) { offEl.hidden = !v.off; offEl.textContent = v.off ? "-" + v.off + "%" : ""; }
      if (buyBtn) {
        buyBtn.disabled = !v.available;
        buyBtn.textContent = v.available ? buyLabel : (S.soldout || "—");
      }
    }
    selects.forEach((s) => s.addEventListener("change", onChange));
  }

  /* ══════════ Mantequilla achuchable del hero ══════════ */
  const butter = $("#HeroButter");
  if (butter) {
    let squishes = 0;
    const hint = $("#SquishHint");
    const press = () => butter.classList.add("pressing");
    const release = () => {
      if (!butter.classList.contains("pressing")) return;
      butter.classList.remove("pressing");
      butter.classList.remove("jelly"); void butter.getBoundingClientRect();
      butter.classList.add("jelly");
      squishes++;
      if (hint) {
        hint.textContent = squishes === 1
          ? (S.squishOne || "1 💛")
          : (S.squishMany || "{{ count }} 💛").replace("{{ count }}", squishes);
      }
    };
    butter.addEventListener("pointerdown", press);
    butter.addEventListener("pointerup", release);
    butter.addEventListener("pointerleave", () => butter.classList.remove("pressing"));
    butter.addEventListener("keydown", (e) => {
      if (e.key === " " || e.key === "Enter") { e.preventDefault(); press(); }
    });
    butter.addEventListener("keyup", (e) => {
      if (e.key === " " || e.key === "Enter") release();
    });
  }
})();